import { render } from "./materialList.vue?vue&type=template&id=5189f176&scoped=true"
import script from "./materialList.vue?vue&type=script&lang=js"
export * from "./materialList.vue?vue&type=script&lang=js"

import "./materialList.vue?vue&type=style&index=0&id=5189f176&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5189f176"]])

export default __exports__